import React from "react";
import ComponentPlacesAutocompleteProps from "../groupTripsMap/PlaceAutocompleteProps";

export default function FormDirection({ setDir }: any) {
  return <ComponentPlacesAutocompleteProps setPlace={setDir} />;
}
